import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {UIBaseModule} from '../../ui-base/ui-base.module';
import {UIFormModule} from '../../ui-form/ui-form.module';
import { ProjectEvidFunctionsLandingComponent } from './components/project-evid-functions-landing/project-evid-functions-landing.component';
import {LinkedEntitiesModule} from "@catmodels/linked-entities/linked-entities.module";
import {ProjectEvidFunctionService} from "@catmodels/project-evid-functions/services/project-evid-function/project-evid-function.service";
import {ParametersModule} from "@catmodels/parameters/parameters.module";
import {ModifyEvidVidComponent} from "@catmodels/project-evid-functions/components/modify-evid-vid/modify-evid-vid.component";

const publicComponents = [
  ProjectEvidFunctionsLandingComponent,
  ModifyEvidVidComponent,
];

const imports = [
  CommonModule,
  ReactiveFormsModule,
  UIBaseModule,
  UIFormModule,
  LinkedEntitiesModule,
  ParametersModule,
];

const entryComponents = [
  ...publicComponents,
];

const declarations = [...publicComponents];
const providers = [ProjectEvidFunctionService];

@NgModule({
  imports,
  declarations,
  entryComponents: [...entryComponents],
  providers,
})
export class ProjectEvidFunctionsModule { }



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/project-evid-functions/project-evid-functions.module.ts